<template>
    <account-common>
        <div class="mc-content">
            <div class="account-header">
                <ul>
                    <li class="active">登录</li>
                    <li class="hand"><a href="#/account/register" class="">注册</a></li>
                </ul>
            </div>
            <div class="account-body">
                <el-form autocomplete="off" :model="loginForm" :rules="rules" ref="loginForm">
                    <el-form-item prop="username">
                        <el-input v-model="loginForm.username" placeholder="登录账号" @focus="accountInput('username', 'focus')" @blur="accountInput('username', 'blur')" class="account-input" :class="inputFocus.username == true ? 'account-input-focus':''">
                            <template slot="prepend">
                                <i class="iconfont icon-yonghuming account-icon"></i>
                            </template>
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input v-model="loginForm.password" show-password placeholder="登录密码" @focus="accountInput('password', 'focus')" @blur="accountInput('password', 'blur')" class="account-input" :class="inputFocus.password == true ? 'account-input-focus':''">
                            <template slot="prepend">
                                <i class="iconfont icon-mima account-icon"></i>
                            </template>
                        </el-input>
                    </el-form-item>
                    <el-form-item class="func-form-item">
                        <span class="pull-left">
                            <el-checkbox v-model="loginForm.rememberAccount">记住账号</el-checkbox>
                        </span>
                        <span class="pull-right">
<!--                            <a href="#/account/forget" class="">忘记密码?</a>-->
                            <a @click="forgetPassword" class="">忘记密码?</a>
                        </span>
                    </el-form-item>
                    <el-form-item class="btn-form-item">
                        <el-button type="primary" @click="onSubmit('loginForm')" class="account-btn" :loading="submitLoading">登录</el-button>
                    </el-form-item>
                </el-form>
                <div class="ivu-spin ivu-spin-fix" v-if="loading">
                    <div class="ivu-spin-main">
                        <span class="ivu-spin-dot"></span>
                        <div class="ivu-spin-text"></div>
                    </div>
                </div>
            </div>

        </div>
    </account-common>
</template>

<script>
    import accountCommon from '../common/Common';
    import axios from 'axios';
    axios.defaults.withCredentials = true;
    export default {
        name: "Login",
        components:{
            accountCommon
        },
        created() {
            const self = this;
            if (localStorage.getItem('rememberAccount') == 'true'){
                self.loginForm.rememberAccount = true;
                let telephone = localStorage.getItem('rememberAccountValue');
                if(telephone != '' && telephone != undefined){
                    self.loginForm.username = telephone;
                }
            }
        },
        data() {
            return {
                loading: false,
                submitLoading: false,
                inputFocus: {
                    username: false,
                    password: false
                },
                loginForm: {
                    username: '',
                    password: '',
                    rememberAccount: false
                },
                rules: {
                    username: [
                        { required: true, message: '请输入登录账号', trigger: 'blur' }
                    ],
                    password: [
                        { required: true, message: '请输入登录密码', trigger: 'blur' }
                    ]
                }
            }
        },
        methods: {
            accountInput(name = 'input', type = 'focus') {
                const self = this;
                self.inputFocus[name] = type == 'focus' ? true : false;
            },
            onSubmit(form){
                const self = this;
                self.$refs[form].validate((valid) => {
                    if (valid) {
                        self.submitLoading = true;
                        axios.post(window.settings.api_url + 'index/account/submit_login', {
                            telephone: self.loginForm.username,
                            password: self.loginForm.password
                        }).then(function(response){
                            self.submitLoading = false;
                            var data = response.data;
                            if (data.error == 0){
                                if(self.loginForm.rememberAccount == true){
                                    localStorage.setItem('rememberAccount', 'true');
                                    localStorage.setItem('rememberAccountValue', self.loginForm.username);
                                }else{
                                    localStorage.removeItem('rememberAccount');
                                    localStorage.removeItem('rememberAccountValue');
                                }
                                // self.$router.push("/shop/list");
                                if (data.result['is_main'] == '1') {
                                    window.location.href = "/manage";
                                } else {
                                    window.location.href = "/warehouse";
                                }
                            }else{
                                self.$message.error(data.result.message);
                                return;
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },
            forgetPassword() {
                this.$alert('请联系您的商务经理', '提示', {
                    confirmButtonText: '好的',
                    callback: action => {

                    }
                });
            }
        }
    }

</script>

<style scoped>

</style>